<footer>
    <p class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
        <a routerLink="/ml-page">Mentions Légales</a> 2021 © DWWM6/CDA6 Tous droits réservés.
    </p>
</footer>
